import React, { useEffect } from 'react'
import { useState } from 'react';
import { env } from '../..';
import { apiFetch } from '../../services'
import Page from './index'

const setRefreshState = (loading, setPageState) => setPageState(current => ({
  ...current,
  loading,
  reload: false,
  keyCnt: current.keyCnt + (current.reinit && !loading ? 1 : 0),
  reinit: !loading ? false : current.reinit
}))
const onClickReload = (setPageState) => (evt) => {
  if (evt.persist instanceof Function) evt.persist();

  setPageState(current => ({
    ...current,
    reload: !!evt.ctrlKey,
    reinit: evt.ctrlKey,
    keyCnt: current.keyCnt + (evt.ctrlKey ? 0 : 1),
    modified: undefined
  }))
}

const setSubscribeState = (subscribed, setPageState) => setPageState(current => ({ ...current, subscribed }))

const subscriptionPolling = (reloadPage, id, modified, currentScope, signal) => 
  apiFetch(`/exec/pages_get/${id}`, { modified }, currentScope, signal)
    .then(resp => {
      if (resp.page) {
        console.log("page updated from server", resp.page.modified)
        reloadPage(resp.page)
      } else if (resp._response.ok) {
        subscriptionPolling(reloadPage, id, modified, currentScope, signal)
      } else {
        console.log("subscription exception", resp);
      }
    })


export const PageLoader = ({ context, modified, lazy, loaded, ...page }) => {
  const dispatch = context.dispatch;
  const currentScope = context.scope?.current
  const { id, title } = page;
  const [{ loading, reload, subscribed, keyCnt, ...state }, setPageState] = useState({ loading: false, reload: false, subscribed: false, modified, keyCnt: 0 });
  const devenv = env !== "production"
  const pageModified = state.modified && state.modified !== modified

  //inicializa state.modified cuando el componente se renderiza desde lazy load.
  useEffect(() => {
    if (!state.modified && modified)
      setPageState(current => ({ ...current, modified }))
  }, [modified, state.modified])

  useEffect(() => {
    if (currentScope && ( reload || !loaded )) {
      setRefreshState(true, setPageState)
      apiFetch(`/exec/pages_get/${id}`, {}, currentScope)
        .then(resp => {
          dispatch({ type: "set-page", payload: resp.page })
          setRefreshState(false, setPageState)
        })
    }
  }, [currentScope, dispatch, id, reload, loaded])

  useEffect(() => {
    if (currentScope && !reload && !loading && devenv) {
      const fetchController = new AbortController()
      setSubscribeState(true, setPageState)
      console.log("subscribing to server modifications");
      subscriptionPolling(payload => dispatch({ type: "set-page", payload }), id, modified, currentScope, fetchController.signal)
      return () => fetchController.abort();
    } else {
      setSubscribeState(false, setPageState)
    }
  }, [currentScope, dispatch, id, reload, loading, modified, devenv])


  return[
    loaded ? <Page key={`pageloader-content-${id}-${keyCnt}`} context={context} {...page} /> : <p key="pageloader-loading">Cargando {title || 'contenido'}.</p> ,
    devenv && (
      <div key="pageloader-debug-info" className="bg-secondary mt-auto p-1 d-flex flex-row-reverse align-items-center" style={{ height: "60px" }} >
        <button
          disabled={loading}
          className={`"btn btn-sm ${ pageModified ? "btn-info" : "btn-light" } mx-1"`}
          onClick={onClickReload(setPageState) }
        >{loading ? "Cargando" : "Recargar"}</button>
        <span className="px-1" >{ subscribed.toString() }</span>
        <span className="px-1" >debug-info</span>
      </div>
    )
  ]
}


export default PageLoader;
